<!-- <div class="button" class="clear" (click)="clearAll()">
	CLEAR
</div> -->
<div class="cycles-week" *ngIf="schedule?.blocks">
	<div class="time-grid">
		<div class="hour-marker"
			*ngFor="let hour of hourMarkers"
			[style.left]="hour / 0.24 + '%'"
		>
			<span class="time">
				{{ hour * 1000 * 60 | date:'mm:ss':'UTC' }}
			</span>
		</div>
	</div>
	<div class="spacer"></div>
	<ng-container
		*ngFor="let block of schedule.blocks; let i = index;"
	>
		<div class="block">
			<div class="block-label" [class.filled]="block.cycles.length && (!gaps[i] || !gaps[i].length)" (click)="log(gaps && gaps[i])">
				{{ getWeekDay(i) }}
			</div>
			<div class="cycle-wrapper">
				<span *ngIf="!block.cycles.length" class="add-cycle button blue" (click)="addCycle(i)">+</span>
				<ng-container *ngIf="block.cycles.length && gaps[i]">
					<div
						*ngFor="let gap of gaps[i]"
						[style.left]="gap.from / (secondsInBlock / 100) + '%'"
						[style.width]="(gap.to - gap.from) / (secondsInBlock / 100) + '%'"
						class="add-cycle button blue with-range" (click)="addCycle(i, gap)"
					>+</div>
				</ng-container>
				<div
					class="cycle"
					(click)="onCycleClick(i, cycleIndex)"
					*ngFor="let cycle of block.cycles; let cycleIndex = index;"
					[class.active]="activeCycle && activeCycle.d === i && activeCycle.c === cycleIndex"
					[style.left]="cycle.from / (secondsInBlock / 100) + '%'"
					[style.width]="(cycle.to - cycle.from) / (secondsInBlock / 100) + '%'"
				>
					<div class="cycle-label">
						{{ cycle?.label }}
					</div>
				</div>
			</div>
		</div>
		<div class="block-edit-cycle" *ngIf="activeCycle && activeCycle.d === i">
			<ng-container *ngFor="let cycle of block.cycles; let cycleIndex = index;">
				<bb-edit-cycle
					*ngIf="activeCycle?.c === cycleIndex"
					name="edit_cycle"
					[min]="block.cycles[cycleIndex - 1] && block.cycles[cycleIndex - 1].to ? block.cycles[cycleIndex - 1].to : 0"
					[max]="block.cycles[cycleIndex + 1] && block.cycles[cycleIndex + 1].from ? block.cycles[cycleIndex + 1].from : secondsInBlock"
					[(ngModel)]="block.cycles[cycleIndex]"
					(ngModelChange)="propagate()"
					(onDelete)="onCycleDeleted(block, cycleIndex)"
				></bb-edit-cycle>
			</ng-container>
		</div>
	</ng-container>
</div>
